<template>
<div class="indexPage" style="height: 100%;position:relative;background:#FFFFFF;">

<div class="mobile-h">
    <headfix></headfix>
</div>


<div class="index_banner">
    <swiper :options="swiperOption" ref="indexSwiper">
       <swiper-slide class="child_banner_item" v-for="(item,index) in advList">
           <img :src="item.advImages" alt="" class="child_banner_img pc" @click="goAdv_(item)" style="object-fit: fill;">
           <img :src="item.advSmallImages1" alt="" class="child_banner_img mobile" @click="goAdv_(item)">
       </swiper-slide>
   </swiper>
    <div class="swiper-button-prev swiper-button-white"></div>
   <div class="swiper-button-next swiper-button-white"></div>
</div>

<!--搜索-->
<div class="search-icon" @click="goSearch_()"></div>


<div class="index-menu">
    <div class="index-menu-item">
        <a href="javascript:;" @click="goCate_('home')">
            <div class="m1">首页</div><div class="m2">HOME PAGE</div>
        </a>
        <div class="split"></div>
    </div>
    <div class="index-menu-item" v-for="(item,index) in cmsCategoryList" @click="goCate_(item)">
        <a href="javascript:;">
           <div class="m1">{{item.categoryName}}</div><div class="m2">{{item.code}}</div>
       </a>
        <div class="split"></div>
    </div>

</div>


<div class="wraper-box" style="position: relative;">


    <div class="box1 pc">
        <div class="about">
            <div class="title">
                <div class="t1">联系我们</div>
                <div class="t2">ABOUT US</div>
            </div>

            <div class="contact">
                <div class="contact-item">
                    <div class="contact-icon"><img src="../../assets/img/index_address.png" /></div>
                    <div class="contact-icon-right">
                        <div class="contact-title">公司地址<span>ADDRESS</span></div>
                        <div class="contact-content">{{setting.address}}</div>
                    </div>
                </div>
                <div class="contact-item">
                     <div class="contact-icon"><img src="../../assets/img/index_phone.png" /></div>
                     <div class="contact-icon-right">
                         <div class="contact-title">联系我们<span>CONTACT US</span></div>
                         <div class="contact-content">{{setting.phone1}}</div>
                     </div>
                 </div>
                <div class="contact-item">
                   <div class="contact-icon"><img src="../../assets/img/index_email.png" /></div>
                   <div class="contact-icon-right">
                       <div class="contact-title">E-MAILE<span>MAILBOX</span></div>
                       <div class="contact-content">{{setting.phone2}}</div>
                   </div>
               </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="partner">
            <div class="title">
               <div class="t1">合作伙伴</div>
               <div class="t2">PARTNER</div>
            </div>
            <div class="partner-box">
                <div class="partner-item" v-for="(item,index) in parterList" @click="goLink_(item)">
                    <div class="partner-logo"><img :src="item.thumb"/></div>
                    <div class="partner-logo-right">
                        <div class="partner-logo-title">{{item.title}}</div>
                        <div class="partner-desc">{{item.description}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>



    <div class="box1 mobile">

        <div class="partner1">
           <div class="title-box1">
               <div class="title1">
                   <div class="t11">合作伙伴</div>
                   <div class="t21">PARTNER</div>
               </div>
           </div>
           <div class="partner-box1">
               <div class="partner-item1" v-for="(item,index) in parterList" @click="goLink_(item)">
                   <div class="partner-logo1"><img :src="item.thumb"/></div>
                   <div class="partner-logo-right1">
                       <div class="partner-logo-title1">{{item.title}}</div>
                       <div class="partner-desc1">{{item.description}}</div>
                   </div>
               </div>
           </div>
       </div>

        <div class="about1">
            <div class="title-box1">
                <div class="title1">
                    <div class="t11">联系我们</div>
                    <div class="t21">ABOUT US</div>
                </div>
            </div>
            <div class="contact1">
                <div class="contact-item1">
                     <div class="contact-icon1" @click="callTel(setting.phone1)"><img src="../../assets/img/index_phone.png" /></div>
                     <div class="contact-icon-right1">
                         <div class="contact-title1">联系我们<span>CONTACT US</span></div>
                         <div class="contact-content1">{{setting.phone1}}</div>
                     </div>
                 </div>
                <div class="contact-item1">
                   <div class="contact-icon1"><img src="../../assets/img/index_address.png" /></div>
                   <div class="contact-icon-right1">
                       <div class="contact-title1">公司地址<span>ADDRESS</span></div>
                       <div class="contact-content1">{{setting.address}}</div>
                   </div>
               </div>
                <div class="contact-item1">
                   <div class="contact-icon1"><img src="../../assets/img/index_email.png" /></div>
                   <div class="contact-icon-right1">
                       <div class="contact-title1">E-MAILE<span>MAILBOX</span></div>
                       <div class="contact-content1">{{setting.phone2}}</div>
                   </div>
               </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>




</div>

    <div class="box2" v-if="productCategory[0]">
        <div class="wraper-box box2-content">
            <div class="box2-left"><div class="product-pic"><img :src="productCategory[0].categoryThumb1"></div></div>
            <div class="box2-right">
                <div class="product-name">{{productCategory[0].categoryName}}</div>
                <div class="product-short-title">{{productCategory[0].code}}</div>
                <div class="product-desc">{{productCategory[0].description}}</div>
                <div class="product-desc1">{{productCategory[0].description1}}</div>
                <div class="product-btn" @click="goCate_(productCategory[0])"><a href="javascript:;">查看详情<i></i></a></div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>


    <div class="box2 mobile" v-if="productCategory[1]">
        <div class="wraper-box box2-content">
            <div class="box2-left"><div class="product-pic"><img :src="productCategory[1].categoryThumb1"></div></div>
            <div class="box2-right">
                <div class="product-name">{{productCategory[1].categoryName}}</div>
                <div class="product-short-title">{{productCategory[1].code}}</div>
                <div class="product-desc">{{productCategory[1].description}}</div>
                <div class="product-desc1">{{productCategory[1].description1}}</div>
                <div class="product-btn" @click="goCate_(productCategory[1])"><a href="javascript:;">查看详情<i></i></a></div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>

    <div class="box3 pc" v-if="productCategory[1]">
        <div class="wraper-box box3-content">
            <div class="box3-left">
                <div class="product-name">{{productCategory[1].categoryName}}</div>
                <div class="product-short-title">{{productCategory[1].code}}</div>
                <div class="product-desc">{{productCategory[1].description}}</div>
                <div class="product-desc1">{{productCategory[1].description1}}</div>
                <div class="product-btn" @click="goCate_(productCategory[1])"><a href="javascript:;">查看详情<i></i></a></div>
            </div>
            <div class="box3-right"><div class="product-pic"><img :src="productCategory[1].categoryThumb1"></div></div>
            <div class="clearfix"></div>
        </div>
    </div>

    <div class="box4">
        <div class="pic pc" v-for="(item,index) in advBottomList">
            <img :src="item.advImages" @click="goAdv_(item)">
        </div>
        <div class="pic mobile" v-for="(item,index) in advBottomList">
            <img :src="item.advSmallImages1" @click="goAdv_(item)">

            <div class="goto goto1" @click="gotoBtn(1)"></div>
            <div class="goto goto2">
                <div class="goto22" @click="gotoBtn(2)"></div>
                <div class="goto222" @click="gotoBtn(3)"></div>
            </div>
            <div class="goto goto3">
                <div class="goto33" @click="gotoBtn(4)"></div>
                <div class="goto333" @click="gotoBtn(5)"></div>
            </div>

        </div>
    </div>

    <div class="index-footer">
        <div class="index-footer-logo"><img :src="setting.siteLogo"></div>
        <div class="index-footer-right" v-html="setting.copyright"></div>
        <div class="clearfix"></div>
    </div>


    <div class="gzh-pop" v-if="gzhShow" @click="changeGzhBox"></div>
    <div class="gzh-box" v-if="gzhShow">
        <img src="../../assets/img/gzh.jpg"/>
        <div class="gzh-text">长按识别二维码或保存</div>
    </div>
</div>




</div>
</template>
<script>
import footerfix from '@/components/utils/footerfix';
import headfix from '@/components/utils/headfix';
import {settingInfo_, categoryTree_, goCate_, goAdv_, goLink_, goSearch_} from '@/components/js/app'
export default {
    components:{headfix,footerfix},
    data(){
        return{
            gzhShow:false,
            cmsCategoryList:[],
            productCategory:[],
            advList:[],
            advBottomList:[],
            parterList:[],
            setting:{},
            form:{
                trueName:'',
                phone:'',
                shenName:'',
                pid:'',
                agree:'',
                txt:''
            },
            swiperOption: {
                autoplay : {
                    disableOnInteraction: false, //用户操作后是否禁止自动循环
                    delay: 6000 //自自动循环时间
                }, //可选选项，自动滑动
                speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
                height: window.innerHeight,
                loop:true, //循环切换
                grabCursor: false, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
                // setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                autoHeight: false,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
                scrollbar: '.swiper-scrollbar',
                observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
                // pagination: {
                //     el: '.one-page',
                //     type : 'bullets', //分页器形状
                //     clickable :true, //点击分页器的指示点分页器会控制Swiper切换
                // },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {

                }
            },

        }
    },

    created() {
        this.$nextTick(()=>{
            this.categoryTree();
            this.getAdvTopData();
            this.settingInfo();
            this.getParterData();
            this.getAdvBottomData();
        })
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF')
    },
    methods : {
        goCate_,
        goAdv_,
        goLink_,
        goSearch_,
        // 头部广告
        getAdvTopData () {
            this.$post_('api/adv/adv-list', {catId: 54}, (res) => {
                if (res.code == 1) {
                    this.advList = res.data;
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        callTel(phone) {
            console.log(phone);
            window.location.href="tel://" + phone;
        },
        // 底部广告
        getAdvBottomData () {
              this.$post_('api/adv/adv-list', {catId: 65}, (res) => {
                  if (res.code == 1) {
                      this.advBottomList = res.data;
                  } else {
                      this.$message.error(res.message);
                  }
              })
          },
        // 顶部导航
        categoryTree() {
              this.$post_('api/cms-category/top-category-tree', {}, (res) => {
                  if (res.code == 1) {
                      this.cmsCategoryList = res.data;
                      for (let i = 0; i < this.cmsCategoryList.length; i++) {
                        if (this.cmsCategoryList[i].id == 36) {
                            this.productCategory = res.data[i].children;
                        }
                      }

                  } else {
                      this.$message.error(res.message);
                  }
              })
        },
        // 配置信息
        settingInfo() {
             this.$post_('api/sys-setting/info', {}, (res) => {
                 if (res.code == 1) {
                     this.setting = res.data;
                 } else {
                     this.$message.error(res.message);
                 }
             });
         },
        // 合作伙伴
        getParterData () {
            this.$post_('api/cms-article/article-page', {page:1,size:6, data:{model_id:1,  categoryId: 49}}, (res) => {
                if (res.code == 1) {
                    this.parterList = res.data.records;
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        gotoBtn(num) {

            if (num==1) {
                this.changeGzhBox();
            } else if (num==2) {
                // 需要用户的userId    759143995815075
                window.location.href="snssdk1128://user/profile/2430336921774891";
            } else if (num==3) {
                // 需要用户的userId   5b31e82ee8ac2b1bff4df7d0
                window.location.href="xhsdiscover://user/6409a8be0000000029014bba";
            } else if (num==4) {
                window.location.href="sinaweibo://userinfo?uid=7826620700";
            } else if (num==5) {
                // BV1tm4y1G7VH
                window.location.href="bilibili://video/703878952";
            }

        },
        changeGzhBox() {
            this.gzhShow = !this.gzhShow;
        }
    },

    mounted() {
        this.$nextTick(() => {

        })
    }
}
</script>

<style scoped>
.gzh-pop{position:fixed;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.6);z-index: 99999998;}
.gzh-box{position:fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);background: #FFFFFF;text-align: center;padding: 10px;z-index: 99999999;}
.gzh-text{margin-bottom: 10px;color: #666666;font-size: 14px;}



.mobile-h{width: 100%;display: none;}
.search-icon{cursor: pointer;background: url("../../assets/img/index_search.png") center center no-repeat;width: 50px;height: 50px;margin-right: 8px;position: absolute; right: 130px;top: 43px;z-index: 1000000;}


.swiper-button-prev{left: 70px;}
.swiper-button-next{right: 70px;}
.swiper-button-prev:after, .swiper-button-next:after{font-size: 58px;width: 2px;}

/*首页滚动*/
.index_banner{overflow: hidden;height: 100%;position: relative;}
.swiper-container{height: 100%;}
.child_banner{height: 100%;}
.child_banner_item{}
.child_banner_item.swiper-slide{height: 100%;}
.child_banner_img{width: 100%;height: 100%;object-fit: cover;position: absolute;left: 0%;top: 0%;}



.child_banner .swiper-container{height: 100%;}
.one-page{z-index: 999;position: absolute;text-align: center;}

.index-menu{height: 200px;margin:0 auto;z-index: 99999999;position: absolute;width: 1470px;bottom: -100px;-webkit-transform: translateX(-50%);left: 50%;
    display: flex;justify-content: space-between;align-items: center;background: url("../../assets/img/index_menu.png") center center no-repeat;background-size: 100% 100%;}
.index-menu-item{height: 100%;display: flex;flex-wrap: wrap;justify-content: center;align-items: center;position: relative;flex: 1;cursor: pointer;}
.index-menu-item a{text-align: center;display: block;}
.index-menu-item .split{background: url("../../assets/img/menu_icon.png") right center no-repeat;position: absolute;top: 5px;right: -14px;width: 28px;height: 100%;}
.index-menu-item:last-child .split{display: none;}
.index-menu-item .m1{font-size: 24px;font-weight: 500;color: #000000;}
.index-menu-item .m2{font-size: 10px;color: #9a9a9a;}


.box1{padding-top: 180px;display: flex;flex-wrap: wrap;}
.box1.mobile{display: none;}
.box1 .title{margin-bottom: 20px;}
.box1 .title{margin-bottom: 20px;}
.box1 .title .t1{font-size: 38px;font-weight: 600;color: #000000;letter-spacing:2px;}
.box1 .title .t2{font-size: 18px;color: #383838;letter-spacing:2px;}






.about{width: 480px;}
.contact{margin-left: -18px;background: url("../../assets/img/about_split.png") right center no-repeat;}
.contact-item{margin-bottom: 20px;display: flex;margin-right: 20px;width: 100%;align-items: center;}
.contact-icon{margin-right: 10px;width: 145px;height:145px;}
.contact-icon img{width: 100%;height: 100%;object-fit: cover;}

.contact-icon-right{flex: 1;padding-right: 70px;}
.contact-title{font-weight: bold;font-size: 24px;color: #e26b26;}
.contact-title span{font-size: 10px;color: #d7d7d7;margin-left: 6px;}
.contact-content{font-size: 18px;color: #747474;margin-top: 10px;}


.partner{flex: 1;padding-left: 60px;}
.partner-box{margin-top: 40px;display: flex;flex-wrap: wrap;}
.partner-item{margin-bottom: 55px;width: 50%;display: flex;padding-right: 20px;cursor: pointer;}
.partner-logo{margin-right: 10px;width: 135px;height: 104px;}
.partner-logo img{width: 100%;height: 100%;object-fit: cover;}
.partner-logo-right{flex: 1;}
.partner-logo-title{font-size: 18px;font-weight: bold;color: #383838;margin-bottom: 10px;}
.partner-desc{font-size: 12px; color: #898989;}




.box2{background: #f6f6f6;}
.box2-content{margin-top: 120px;padding-bottom: 20px;}
.box2-left{width: 500px;height: 100%;position: relative;float: left;height: 500px;}
.box2-left .product-pic{position: absolute;top: -60px;width: 100%;height: 100%;}
.box2-left .product-pic img{width: 100%;height: 100%;object-fit: cover;}
.box2-right{overflow: hidden;float: right;width: 450px;padding-top: 60px;}
.box2-right .product-name{font-size: 38px;font-weight: bold;letter-spacing:2px;color: #373737;}
.box2-right .product-short-title{font-size: 18px;color: #868686;margin-bottom: 40px;}
.box2-right .product-desc{font-size: 14px;color: #959595;margin-bottom: 30px;}
.box2-right .product-desc1{font-size: 12px;color: #cacaca;margin-bottom: 30px;word-wrap:break-word;}

.product-btn a{display:inline-block;background: #e66b28;color: #FFFFFF;font-size: 18px;letter-spacing:2px;font-weight:bold;padding: 10px 50px 10px 15px;border-radius: 8px;position: relative;}
.product-btn i{background: url(../../assets/img/detail.png) no-repeat center center;display: inline-block;height: 23px;width: 23px;color: #FFF;margin-left: 5px;position: absolute;top:12px;}


.box3{background: #ececec;}
.box3-content{}
.box3-left{width: 530px;float: left;overflow: hidden;padding-top: 60px;padding-bottom: 50px;}
.box3-left .product-name{font-size: 38px;font-weight: bold;letter-spacing:2px;color: #373737;}
.box3-left .product-short-title{font-size: 18px;color: #868686;margin-bottom: 40px;}
.box3-left .product-desc{font-size: 14px;color: #959595;margin-bottom: 30px;}
.box3-left .product-desc1{font-size: 12px;color: #cacaca;margin-bottom: 30px;word-wrap:break-word;}
.box3-right{width: 570px;height: 100%;position: relative;float: right;height: 500px;}
.box3-right .product-pic{position: absolute;top: -60px;width: 100%;height: 100%;}
.box3-right .product-pic img{width: 100%;height: 100%;object-fit: cover;}



.box4{height: 650px;position: relative;}
.box4 .pic{width: 100%;height: 100%;text-align: center;}
.box4 .pic img{object-fit: cover;width: 100%;height: 100%;}

.goto{position: absolute;width: 100%;left: 90px;}
.goto1{width: 50%;height: 100px;background: #ffffff;top:220px;}
.goto2{width: 50%;height: 100px;background: #ffffff;top:340px;display: flex;}
.goto22{width: 50%;height: 100px;background: #FF0000;}
.goto222{width: 50%;height: 100px;background: #F0AD4E;}


.goto3{width: 50%;height: 100px;background: #ffffff;top:460px;display: flex;}
.goto33{width: 50%;height: 100px;background: #FF0000;}
.goto333{width: 50%;height: 100px;background: #F0AD4E;}

.goto1,.goto2,.goto22,.goto222,.goto3,.goto33,.goto333{background: none;-webkit-tap-highlight-color: rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;}




.index-footer{background: #e66b28;padding: 40px 50px;border-top: #ef8e27 15px solid;word-break: break-all;}
.index-footer-logo{margin-right: 50px;float: left;}
.index-footer-logo img{width: 190px;height: 50px;object-fit: cover;}
.index-footer-right{color: #FFFFFF; font-size: 16px;float: right;word-wrap:break-word;width: 900px;}

@media (max-width:1799px){

    .index-menu{width: 1300px;}

    .box2-left{width: 570px;}
    .box2-right{width: 530px;}
    .box3-left{width: 530px;}
    .box3-right{width: 570px;}



    .box1 .partner{width:800px;}


}
@media (max-width:1379px){

    .index-menu{width: 1100px;}
}
@media (max-width:1199px){

    .search-icon{right: 100px;}
    .index-menu{width: 1000px;}

    .box2-left{width: 500px;}
    .box2-right{width: 400px;}
    .box3-left{width: 400px;}
    .box3-right{width: 500px;}
    .index-footer-right{width: 700px}


    .about{width: 100%;}
    .contact{background: none;}
    .partner{padding-left: 0px;margin-top: 40px;}

    .box1 .partner{width:620px;}


}
@media (max-width:993px){
    .search-icon{display: none;}
    /*.index_banner{overflow: hidden;height: 100%;position: relative;}*/
    /*.swiper-container{height: 100%;}*/
    /*.child_banner{height: auto;}*/
    /*.child_banner_item{}*/
    /*.child_banner_item.swiper-slide{height: auto;}*/
    /*.child_banner_img{max-width: 100%;height: auto;object-fit: cover;}*/
    .index_banner{height: calc(100% - 56px);}
    .child_banner_img{height: 100%;}



    .swiper-button-prev{left: 20px;}
    .swiper-button-next{right: 20px;}
    .swiper-button-prev:after, .swiper-button-next:after{font-size: 28px;width: 2px;}

    .index-menu{display: none;}
    .mobile-h{display: block;}
    .box1{padding: 20px;padding-bottom: 0px;}
    .box1 .title{margin-bottom: 20px;}
    .box1 .title .t1{font-size: 24px;font-weight: 600;color: #000000;}
    .box1 .title .t2{font-size: 14px;color: #383838;}




    .title-box1{text-align: center;margin: 30px 0px;}
    .title1{display: inline-block;border-bottom: #ef8e27 3px solid;padding: 5px 10px;}
    .title1 .t11{font-size: 24px;font-weight: 600;color: #000000;}
    .title1 .t21{font-size: 14px;color: #383838;}

    .partner1{}
    .partner1 .partner-box1{margin-top: 40px;display: flex;flex-wrap: wrap;}
    .partner1 .partner-item1{margin-bottom: 25px;width: 50%;display: flex;cursor: pointer;padding: 10px;}
    .partner1 .partner-logo1{margin-right: 10px;width: 75px;height: 64px;}
    .partner1 .partner-logo1 img{width: 100%;height: 100%;object-fit: cover;}
    .partner1 .partner-logo-right1{flex: 1;}
    .partner1 .partner-logo-title1{font-size: 14px;font-weight: bold;color: #383838;margin-bottom: 10px;}
    .partner1 .partner-desc1{font-size: 10px; color: #898989;}


    .about1{width: 100%;}
    .contact1{display: flex;}
    .contact-item1{margin-bottom: 20px;width: 33.33%;align-items: center;text-align: center;display: flex;flex-direction: column;}
    .contact-icon1{width: 85px;height:85px;}
    .contact-icon1 img{width: 100%;height: 100%;object-fit: cover;}

    .contact-icon-right1{margin-top: 10px;}
    .contact-title1{font-weight: bold;font-size: 14px;color: #e26b26;}
    .contact-title1 span{font-size: 10px;color: #d7d7d7;display: block;}
    .contact-content1{font-size: 10px;color: #747474;margin-top: 10px;}







    .contact{}
    .contact-icon{width: 120px;height: 120px;}
    .contact-icon-right{padding-right: 20px;}
    .contact-title{font-size: 24px;}
    .contact-content{font-size: 14px;}

    .product-btn a{font-size: 14px;padding: 5px 35px 5px 10px;}
    .product-btn i{top: 3px;}


    .box2-left{width: 100%;float: none;height: 250px;}
    .box2-right{width: 100%;float: none;padding-top: 40px;}
    .box2-left .product-pic{top:0px;}
    .box2-right .product-name{font-size: 24px;}
    .box2-right .product-short-title{font-size: 14px;}
    .box2-content{padding: 20px;margin-top: 0px;}

    .box2.mobile{padding-top: 40px;padding-bottom: 30px;}
    .box2.mobile .box2-left{height: 360px;}


    .box3-left{width: 100%;float: none;padding-top: 10px;}
    .box3-left .product-name{font-size: 24px;}
    .box3-left .product-short-title{font-size: 14px;}
    .box3-right{width: 100%;float: none;height: 320px;}
    .box3-right .product-pic{top:0px;position: relative;}
    .box3-content{padding: 10px;}

    .box4{height: 100%;}
    .box4 .pic{width: 100%;height: 100%;text-align: center;}
    .box4 .pic img{object-fit: cover;width: 100%;height: 100%;}




    .index-footer{text-align: center;}
    .index-footer-logo{float: none;}
    .index-footer-right{float: none;margin-top: 20px;width: 100%;font-size: 14px;}

}
@media (max-width:767px){
    .index_banner{height: calc(100% - 56px);}
    .child_banner_img{height: 100%;}


}

</style>
